/* eslint-disable no-throw-literal */
import {
  GET_SERVICE_QUESTION_ALL,
  GET_SERVICE_QUESTION_LIST,
  SERVICE_QUESTION_DELETE,
  SERVICE_QUESTION_CREATE,
  GET_SERVICE_QUESTION_DETAIL,
  SERVICE_QUESTION_UPDATE,
  GET_SERVICE_RESULT_LIST,
  GET_SERVICE_RESULT_DETAIL,
  DOWNLOAD_SERVICE_RESULT_DETAIL,
  DELETE_SERVICE_RESULT_DETAIL,
  GET_SERVICE_RESULT_COMMENT,
  UPDATE_SERVICE_RESULT_COMMENT,
  DOWNLOAD_SERVICE_RESULT_LIST,
  DELETE_SERVICE_RESULT_LIST,
  GET_SHOP_SERVICE_RESULT_LIST,
  DOWNLOAD_SHOP_SERVICE_RESULT_LIST,
  DELETE_SHOP_SERVICE_RESULT_LIST,
  DOWNLOAD_NO_ANSWER_LIST,
  DELETE_NO_ANSWER_LIST,
  UPDATE_SERVICE_QUESTION_ANSWER_HIDDEN,
  DOWNLOAD_SHOP_SERVICE_DETAIL_DOWNLOAD,
  DELETE_SHOP_SERVICE_DETAIL_DOWNLOAD,
  DOWNLOAD_ALL_ANSWER_LIST,
  DELETE_ALL_ANSWER_LIST
} from './mutation-types'

export default {
  state: {
    serviceQuestionSearchShopId: undefined,
    serviceQuestionSearchYear: undefined,
    serviceQuestionSearchMonth: undefined
  },
  getters: {
    serviceQuestionSearchShopId: state => {
      return state.serviceQuestionSearchShopId
    },
    serviceQuestionSearchYear: state => {
      return state.serviceQuestionSearchYear
    },
    serviceQuestionSearchMonth: state => {
      return state.serviceQuestionSearchMonth
    }
  },
  actions: {
    async [GET_SERVICE_QUESTION_ALL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_questions/all_get', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    [GET_SERVICE_QUESTION_LIST] ({ dispatch }, params) {
      console.log('GET_SERVICE_QUESTION_LIST')
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/services/service_questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [SERVICE_QUESTION_DELETE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiDelete', {url: `/master/services/service_questions/${params.data.id}`})
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [SERVICE_QUESTION_CREATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/master/services/service_questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [GET_SERVICE_QUESTION_DETAIL] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/services/service_questions/${params.id}/edit` })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [SERVICE_QUESTION_UPDATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/services/service_questions/${params.id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    async [GET_SERVICE_RESULT_LIST] ({ dispatch, state }, params) {
      state.serviceQuestionSearchShopId = params.data['shop_id']
      state.serviceQuestionSearchYear = params.data['year']
      state.serviceQuestionSearchMonth = params.data['month']
      const res = await dispatch('apiGet', { url: '/master/services/service_question_answers', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_SERVICE_RESULT_DETAIL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_detail', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DOWNLOAD_SERVICE_RESULT_DETAIL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_detail/download', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_SERVICE_RESULT_DETAIL] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/master/services/service_question_detail/delete_file', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DOWNLOAD_SERVICE_RESULT_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_answers/download', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_SERVICE_RESULT_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/master/services/service_question_answers/delete_file', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_SHOP_SERVICE_RESULT_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/shop_service_question_answers', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DOWNLOAD_SHOP_SERVICE_RESULT_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/shop_service_question_answers/shop_download', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_SHOP_SERVICE_RESULT_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/master/services/shop_service_question_answers/delete_file', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DOWNLOAD_NO_ANSWER_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_answers/no_answer_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_NO_ANSWER_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/master/services/service_question_answers/delete_file', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DOWNLOAD_SHOP_SERVICE_DETAIL_DOWNLOAD] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_answers/shop_detail_download', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_SHOP_SERVICE_DETAIL_DOWNLOAD] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/master/services/service_question_answers/delete_file', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_SERVICE_RESULT_COMMENT] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_comment', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    [UPDATE_SERVICE_RESULT_COMMENT] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/master/services/service_question_comment', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [UPDATE_SERVICE_QUESTION_ANSWER_HIDDEN] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/services/service_question_answers/${params.id}/hidden`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data && res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          } else {
            reject(new Error(`HTTP ${res.status}: ${res.statusText}`))
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    async [DOWNLOAD_ALL_ANSWER_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/services/service_question_answers/all_answer_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_ALL_ANSWER_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: '/master/services/service_question_answers/delete_file', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/service-question.js